import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {Appointment} from '../../landing/models';
import {FileManagerService} from '../../modules/file-manager/file-manager.service';
import {AppointmentDocumentDataModel} from '../../models/appointments/appointment-document-data.model';
import {DocumentDisplayDialogComponent} from '../document-display-dialog/document-display-dialog.component';
import {DocumentDataModel} from '../../models/document/document-data.model';
import {DocumentUploadModel} from '../../models/document/document-upload.model';
import {DocumentClassEnum} from '../../models/enum/document/document-class.enum';
import {DocumentTypeEnum} from '../../models/enum/document/document-type.enum';
import {SchedulingService} from '../../modules/scheduling/scheduling.service';

@Component({
  selector: 'app-patient-checkin-upload-dialog',
  templateUrl: './patient-checkin-upload-dialog.component.html',
  styleUrls: ['./patient-checkin-upload-dialog.component.scss']
})
export class PatientCheckinUploadDialogComponent implements OnInit {
  uploadedItems: AppointmentDocumentDataModel[] = [];
  selectedAppointmentData: AppointmentDocumentDataModel;
  documents: DocumentDataModel[] = [];

  constructor(private dialogRef: MatDialogRef<PatientCheckinUploadDialogComponent>,
              private fileManagerService: FileManagerService,
              private scheduleService: SchedulingService,
              private dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: Appointment) { }

  ngOnInit(): void {
    this.scheduleService.getDocuments(this.data.AppointmentId).subscribe((res) => {
      this.uploadedItems = res;
    });
  }

  onFilesChanged(files: FileList) {
    const xfiles = Array.from(files);
    for (const file of xfiles) {
      console.log('File name: ' + file.name);
      const item = new AppointmentDocumentDataModel();
      item.file = file;
      item.OriginalFileName = file.name;
      this.uploadedItems.push(item);
    }
  }

  onShowImage(item: AppointmentDocumentDataModel) {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    if (item.file) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        config.data = event.target.result;
        this.dialog.open(DocumentDisplayDialogComponent, config);
      };
      reader.readAsDataURL(item.file);
    } else {
      const docModel = new DocumentDataModel();
      docModel.PatientId = item.PatientId;
      docModel.DocumentID = item.DocumentID;
      const idx = item.OriginalFileName.lastIndexOf('.');
      const extension = item.OriginalFileName.substring(idx + 1, item.OriginalFileName.length);
      docModel.DocumentFileName = item.DocumentID + '.' + extension;
      config.data = this.fileManagerService.getDocumentUrlFromDocument(docModel);
      this.dialog.open(DocumentDisplayDialogComponent, config);
    }
  }

  onFileChanged(file: File) {
    this.selectedAppointmentData.file = file;
    this.selectedAppointmentData.OriginalFileName = file.name;
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    const newItems = this.uploadedItems.filter(p => !p.DocumentID);
    const toUpload: DocumentUploadModel[] = [];
    for (const item of newItems) {
      const model = new DocumentUploadModel();
      model.patientId = this.data.PatientId;
      model.blob = item.file;
      model.docClassId = DocumentClassEnum.Original;
      model.docTypeId = DocumentTypeEnum.Scan;
      model.hasAnnotation = false;
      model.docTagIds = [];
      toUpload.push(model);
    }

    if (toUpload.length > 0) {
      this.fileManagerService.uploadDocuments(toUpload).subscribe((res) => {
        const toRegister: AppointmentDocumentDataModel[] = [];
        let idx = 0;
        for (const doc of res.documents) {
          const mod = new AppointmentDocumentDataModel();
          mod.PatientId = this.data.PatientId;
          mod.AppointmentId = this.data.AppointmentId;
          mod.DocumentID = doc.ParentDocumentID;
          mod.OriginalFileName = newItems[idx].OriginalFileName;
          mod.DocFrom = newItems[idx].DocFrom;
          mod.Description = newItems[idx].Description;
          toRegister.push(mod);
          idx++;
        }

        for (const old of this.uploadedItems) {
          if (old.DocumentID) {
            toRegister.push(old);
          }
        }

        this.scheduleService.registerDocuments(toRegister).subscribe((res1) => {
          this.uploadedItems = res1;
        });
      });
    } else {
      this.scheduleService.registerDocuments(this.uploadedItems).subscribe((res1) => {
        this.uploadedItems = res1;
      });
    }

    this.dialogRef.close();
  }

  getName(item: AppointmentDocumentDataModel) {
    if (!item.DocumentID) {
      return item.file.name;
    } else {
      return item.OriginalFileName;
    }
  }

  getDate(item: AppointmentDocumentDataModel) {
    if (item.xauditCreatedOn) {
      return new Date(item.xauditCreatedOn).toLocaleDateString();
    } else {
      return new Date().toLocaleDateString();
    }
  }
}
